import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dynamicBreadCrumbs: {},
};

export const projectsSlice = createSlice({
  name: "projects",
  initialState: initialState,
  reducers: {
    setDynamicBreadcrumbs: (state, actions) => {
      state.dynamicBreadCrumbs = {
        ...state.dynamicBreadCrumbs,
        ...actions.payload,
      };
    },
  },
});
